import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

import { fetchProfile } from "../../slices/thunks";
// Import avatar image
import avatar1 from "../../assets/images/users/avatar-1.jpg";

const ProfileDropdown = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchProfile());
  }, [dispatch]);

  const user = useSelector((state) => state.Profile.user);
  const userName = user ? `${user.firstname} ${user.lastname}` : "User";

  // Get profile image URL
  const getProfileImageUrl = (imagePath) => {
    if (!imagePath) return avatar1;
    
    // If it's already a full URL, return as is
    if (imagePath.startsWith('http')) {
      return imagePath;
    }
    
    // Remove leading slash if present to avoid double slashes
    const cleanPath = imagePath.startsWith('/') ? imagePath.slice(1) : imagePath;
    
    // Construct full URL using environment variable
    const baseUrl = process.env.REACT_APP_API_URL || "http://192.168.29.223:3001/";
    return `${baseUrl}${cleanPath}`;
  };

  // Get the profile image source
  const profileImageSrc = user?.profileimg 
    ? getProfileImageUrl(user.profileimg)
    : user?.profileImage 
    ? getProfileImageUrl(user.profileImage)
    : user?.avatar 
    ? getProfileImageUrl(user.avatar)
    : user?.image 
    ? getProfileImageUrl(user.image)
    : avatar1;

  // Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  return (
    <Dropdown
      isOpen={isProfileDropdown}
      toggle={toggleProfileDropdown}
      className="ms-sm-3 header-item topbar-user"
    >
      <DropdownToggle tag="button" type="button" className="btn">
        <span className="d-flex align-items-center">
          <img
            className="rounded-circle header-profile-user"
            src={profileImageSrc}
            alt="Profile Avatar"
            onError={(e) => {
              // If profile image fails to load, fall back to default avatar
              if (e.target.src !== avatar1) {
                e.target.src = avatar1;
                e.target.onerror = null; // Prevent infinite loop
              }
            }}
          />
          <span className="text-start ms-xl-2">
            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
              {userName}
            </span>
          </span>
        </span>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end">
        <h6 className="dropdown-header">Welcome {userName}!</h6>
        <DropdownItem className="p-0">
          <Link to="/profile" className="dropdown-item">
            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Profile</span>
          </Link>
        </DropdownItem>
        <div className="dropdown-divider"></div>
        <DropdownItem className="p-0">
          <Link to="/logout" className="dropdown-item">
            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
            <span className="align-middle">Logout</span>
          </Link>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ProfileDropdown;